import React from 'react'
import { useNavigate } from 'react-router-dom'
import ClientsSaySlider from '../component/ClientsSaySlider'
import LatestBlog from '../component/LatestBlog'
import FixHeader from '../component/FixHeader'
import Footer from '../component/Footer'
import Loader from '../component/Loader'

const Services2 = () => {
    const navigate = useNavigate()
    return (
        <>
            <Loader />
            <FixHeader />
            {/* <!-- ====================================== Services Section One ===================================== --> */}
            <section className="section-breadcrumb-img" id="about-section-one">
                <div className="container breadcrumb-main">
                    <h1 className="about-h1-text" data-aos="fade-down">Services</h1>
                    <ul className="breadcrumb-list about-breadcrumb aos-init aos-animate" data-aos="fade-up">
                        <li className="line-slash" onClick={() => navigate("/")}>Home</li>
                        <li className="line-slash" onClick={() => navigate("/Services2")}>Services</li>
                        <li className="active-breadcrumb" onClick={() => navigate("/ServicesDetails2")}>Services 2</li>
                    </ul>
                </div>
            </section>
            {/* <!-- ====================================== Services Section Two ===================================== --> */}
            <section className="about-section-two">
                <div className="container overflow-hidden">
                    <h2 className=" section-heading-text services-page-one-text-main" data-aos="fade-down"><span> Content
                        Write</span> Services</h2>
                    <p className="section-sub-text pharetra" data-aos="fade-down">Pharetra elementum risus quam et
                        adipiscing ac tempor. Donec gravida sagittis elit ullamcorper sed phasellus tincidunt velit
                        ultricies commodo.</p>
                    <div className="new-services cursor-link-blog-post-1" data-aos="fade-up" onClick={() => navigate("/ServicesDetails1")}>
                        <div className="number-hedaing">
                            <h3 className="numbers-services">1.</h3>
                            <h3 className="services-heading">Web Copywriter</h3>
                        </div>
                        <div className="umber-hedaing-sub">
                            <h3 className="strategy">Strategy that involves creating and sharing content on social a
                                website's media platforms.Strategy that involves creating and sharing content on social
                                a website's media platforms.
                            </h3>
                            <button className="tag-button-services">Typography</button>
                            <button className="tag-button-services">Usability</button>
                            <button className="tag-button-services">Hierachy</button>
                        </div>
                    </div>
                    <div className="new-services cursor-link-blog-post-2" data-aos="fade-up" onClick={() => navigate("/ServicesDetails2")}>
                        <div className="number-hedaing">
                            <h3 className="numbers-services">2.</h3>
                            <h3 className="services-heading">Brochure Copywriter.</h3>
                        </div>
                        <div className="umber-hedaing-sub">
                            <h3 className="strategy">Strategy that involves creating and sharing content on social a website's
                                media platforms.Strategy that involves creating and sharing content on social a website's
                                media platforms.
                            </h3>
                            <button className="tag-button-services">Typography</button>
                            <button className="tag-button-services">Usability</button>
                            <button className="tag-button-services">Hierachy</button>
                        </div>
                    </div>
                    <div className="new-services cursor-link-blog-post-3" data-aos="fade-up" onClick={() => navigate("/ServicesDetails3")}>
                        <div className="number-hedaing">
                            <h3 className="numbers-services">3.</h3>
                            <h3 className="services-heading">Digital Copywriting.</h3>
                        </div>
                        <div className="umber-hedaing-sub">
                            <h3 className="strategy">Strategy that involves creating and sharing content on social a website's
                                media platforms.Strategy that involves creating and sharing content on social a website's
                                media platforms.
                            </h3>
                            <button className="tag-button-services">Typography</button>
                            <button className="tag-button-services">Usability</button>
                            <button className="tag-button-services">Hierachy</button>
                        </div>
                    </div>
                    <div className="new-services cursor-link-blog-post-4" data-aos="fade-up" onClick={() => navigate("/ServicesDetails1")}>
                        <div className="number-hedaing">
                            <h3 className="numbers-services">4.</h3>
                            <h3 className="services-heading">Email Copywriting.</h3>
                        </div>
                        <div className="umber-hedaing-sub">
                            <h3 className="strategy">Strategy that involves creating and sharing content on social a website's
                                media platforms.Strategy that involves creating and sharing content on social a website's
                                media platforms.
                            </h3>
                            <button className="tag-button-services">Typography</button>
                            <button className="tag-button-services">Usability</button>
                            <button className="tag-button-services">Hierachy</button>
                        </div>
                    </div>
                    <div className="new-services cursor-link-blog-post-5" data-aos="fade-up" onClick={() => navigate("/ServicesDetails2")}>
                        <div className="number-hedaing">
                            <h3 className="numbers-services">5.</h3>
                            <h3 className="services-heading">Blog Content Writer.</h3>
                        </div>
                        <div className="umber-hedaing-sub">
                            <h3 className="strategy">Strategy that involves creating and sharing content on social a website's
                                media platforms.Strategy that involves creating and sharing content on social a website's
                                media platforms.
                            </h3>
                            <button className="tag-button-services">Typography</button>
                            <button className="tag-button-services">Usability</button>
                            <button className="tag-button-services">Hierachy</button>
                        </div>
                    </div>
                    <div className="new-services cursor-link-blog-post-6" data-aos="fade-up" onClick={() => navigate("/ServicesDetails3")}>
                        <div className="number-hedaing">
                            <h3 className="numbers-services">6.</h3>
                            <h3 className="services-heading">Press Release Writer.</h3>
                        </div>
                        <div className="umber-hedaing-sub">
                            <h3 className="strategy">Strategy that involves creating and sharing content on social a website's
                                media platforms.Strategy that involves creating and sharing content on social a website's
                                media platforms.
                            </h3>
                            <button className="tag-button-services">Typography</button>
                            <button className="tag-button-services">Usability</button>
                            <button className="tag-button-services">Hierachy</button>
                        </div>
                    </div>
                    <div className="new-services cursor-link-blog-post-7" data-aos="fade-up" onClick={() => navigate("/ServicesDetails1")}>
                        <div className="number-hedaing">
                            <h3 className="numbers-services">7.</h3>
                            <h3 className="services-heading">Video Script Writer.</h3>
                        </div>
                        <div className="umber-hedaing-sub">
                            <h3 className="strategy">Strategy that involves creating and sharing content on social a website's
                                media platforms.Strategy that involves creating and sharing content on social a website's
                                media platforms.
                            </h3>
                            <button className="tag-button-services">Typography</button>
                            <button className="tag-button-services">Usability</button>
                            <button className="tag-button-services">Hierachy</button>
                        </div>
                    </div>
                    <div className="cursor cursor-shadow"></div>
                </div>
            </section>
            {/* <!-- ====================================== About Section Six ===================================== --> */}
            <ClientsSaySlider />
            {/* <!-- ====================================== About Section Seven ===================================== --> */}
            <LatestBlog />
            <Footer />
        </>
    )
}

export default Services2